var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { IconOptions } from "./iconOptions";
export var getIcon = function (glyph) {
    var iconType = IconOptions[glyph].type === "pro" ? "glyphicon-pro" : "glyphicon";
    var iconValue = IconOptions[glyph].value;
    return { iconType: iconType, iconValue: iconValue };
};
export var setIcon = function (glyph) {
    return typeof glyph == "undefined"
        ? { iconType: undefined, iconValue: undefined }
        : getIcon(glyph);
};
export var getIconKeys = function () {
    var icons = [];
    Object.keys(IconOptions).forEach(function (key) {
        icons = __spreadArray(__spreadArray([], icons, true), [key], false);
    });
    return icons;
};
